import React, { useContext, useEffect, useMemo, useState } from 'react';


function createStatefulContext(defaultValue) {
  const setterContext = React.createContext();

  setterContext.ProviderComponent = function({ children }) {
    const [value, setValue] = useState(defaultValue);

    const contextValue = useMemo(
      () => ({
        value,
        set: setValue,
      }),
      [value]
    );

    return <setterContext.Provider value={contextValue}>{children}</setterContext.Provider>;
  };

  setterContext.SetValue = function(props) {
    const { value } = props;
    const contextValue = useContext(setterContext);
    const dependencies = Object.entries(props)
      .filter(([k, v]) => /^dep\d+$/.test(k))
      .map(([k, v]) => v);

    useEffect(() => {
      const oldValue = contextValue.value;
      contextValue.set(value);
      return () => {
        contextValue.set('unsetTo' in props ? props.unsetTo : oldValue);
      };
    }, dependencies);
    return null;
  };

  return setterContext;
}

export default createStatefulContext;
